/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Visitors_TitleInputs */

const en_directory_rails_visitors_title = /** @type {(inputs: Directory_Rails_Visitors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly Visitors`)
};

const zh_directory_rails_visitors_title = /** @type {(inputs: Directory_Rails_Visitors_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月访问量`)
};

/**
* | output |
* | --- |
* | "Monthly Visitors" |
*
* @param {Directory_Rails_Visitors_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_visitors_title = /** @type {((inputs?: Directory_Rails_Visitors_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Visitors_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_visitors_title(inputs)
	return zh_directory_rails_visitors_title(inputs)
});
export { directory_rails_visitors_title as "directory.rails.visitors_title" }